import { toast } from "react-toastify";
import { log } from "../../Helper";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT } from "../../constants/constants";

export const callEndDateAPI = async (selectedProviderId, selectedEndDate) => {
    let url = `${process.env.REACT_APP_API_ENDPOINT}/masterdata/endDateForwarder`;
    const requestOptions = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
          "providerId": selectedProviderId,
          "endDate": selectedEndDate
        },
    };
  
    try {
      const response = await fetch(url, requestOptions);
      if (response) {
        const result = await response.json(); 
        return result;
      }
    } catch (error) {
      log("Error while calling provider endDate API: ", error);
      toast.error("An error occurred while setting end date. Please try again");
    }
    return null;
};